export enum CDMVersion {
  V5_0 = 'V5_0',
  V5_0_1 = 'V5_0_1',
  V5_1 = 'V5_1',
  V5_2 = 'V5_2',
  V5_3 = 'V5_3',
  V5_3_1 = 'V5_3_1',
  V5_4 = 'V5_4',
  V6_0 = 'V6_0',
}
